var map = {
	"./technical_parts.jpg": 216,
	"./technical_parts1.jpg": 217
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;


//////////////////
// WEBPACK FOOTER
// ./src/images/technicalProducts nonrecursive \.(png|jpe?g|svg)$
// module id = 215
// module chunks = 0